import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f3efafc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "qr-code-dialog"
}
const _hoisted_2 = {
  class: "qr-code-dialog-container",
  ref: "container"
}
const _hoisted_3 = { class: "qr-code-frame-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_qrcode_canvas = _resolveComponent("qrcode-canvas")!

  return (_ctx.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('export_favorites_hint')), 1),
            _createVNode(_component_qrcode_canvas, {
              value: _ctx.qrCodeData,
              size: 200,
              level: "H",
              "render-as": "svg"
            }, null, 8, ["value"])
          ])
        ], 512)
      ]))
    : _createCommentVNode("", true)
}